<template>
    <UserPageLayout>
        <div class="max-w-md mx-auto pt-12">
            <div class="bg-white rounded shadow-lg px-5 py-6">
                <InnerLoader v-if="!status" class="payment-loading custom-loading" :z-index="999" />
                <div v-if="status">
                    <div v-if="checkOpener" class="w-full text-center mb-4">
                        {{ $t('vipps_close_window_in') }} {{ closeTimer }}
                    </div>
                    <div class="text-center">
                        <i
                            :class="{
                                'far text-6xl': true,
                                'fa-check-circle text-green': status == 'RESERVE',
                                'fa-times-circle text-red': status == 'CANCEL',
                                'fa-hand-paper text-grey': status == 'INITIATE'
                            }"
                        ></i>
                    </div>
                    <div class="text-center">
                        <h1 v-if="status == 'RESERVE'" class="text-3xl shadow-text-none">{{ $t('vipps_thanks') }}</h1>
                        <h1 v-if="status == 'INITIATE'" class="text-3xl shadow-text-none">
                            {{ $t('vipps_payment_cancelled') }}
                        </h1>
                        <h1 v-if="status == 'CANCEL'" class="text-3xl shadow-text-none">
                            {{ $t('vipps_payment_failed') }}
                        </h1>
                        <p class="pb-6">
                            <span class="shadow-text-none" v-if="status == 'RESERVE' && vippsType != 'ai-question'">
                                {{
                                    $t('vipps_success_message', {
                                        plan: priceMessage
                                    })
                                }}
                            </span>
                            <span class="shadow-text-none" v-if="status == 'INITIATE'">{{
                                $t('vipps_unsubscribe_message')
                            }}</span>
                            <span class="shadow-text-none" v-if="status == 'CANCEL'">{{
                                $t('vipps_payment_was_no_success')
                            }}</span>
                            <span class="shadow-text-none" v-if="vippsType == 'ai-question'">
                                {{
                                    $t('vipps_ai_question_success_message', {
                                        plan: priceMessage,
                                        limit: limitQuestions
                                    })
                                }}
                            </span>
                        </p>
                    </div>
                    <div class="text-center mt-3">
                        <button
                            v-if="checkOpener"
                            type="button"
                            class="btn btn-lg text-xl uppercase font-opensans"
                            @click="closeAction"
                        >
                            {{ $t('vipps_payment_close') }}
                        </button>
                        <button v-else type="button" class="btn btn-lg text-xl font-opensans" @click="doneAction">
                            {{ checkIsLoggedIn && currentUser().id.length ? 'My Order' : 'Done' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </UserPageLayout>
</template>

<script>
import InnerLoader from '@/components/InnerLoader'
import UserPageLayout from '@/layouts/UserPage'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import { currentUser, isLoggedIn } from '@/lib/user.js'

export default {
    components: {
        UserPageLayout,
        InnerLoader
    },

    mounted() {
        this.checkStatus()
    },

    data() {
        return {
            closeTimer: '...',
            timerInterval: null,
            status: null,
            transactionInfo: '',
            vippsType: '',
            limitQuestions: 0,
            priceMessage: '',
            userInfo: {
                name: null,
                email: null,
                id: null
            }
        }
    },

    computed: {
        checkOpener() {
            return window.opener && window.opener != undefined
        },

        checkIsLoggedIn() {
            return isLoggedIn()
        }
    },

    watch: {
        closeTimer(val) {
            if (val <= 0) {
                this.closeAction()
            }
        }
    },

    methods: {
        async checkStatus() {
            const token = new URLSearchParams(location.search).get('token')
            var orderId = window.localStorage.getItem(`${currentUser().id}-vipps-orderId`)
            let quizId = ''

            if (token) {
                try {
                    let orderToken = await this.createOrderByToken(token)
                    orderId = orderToken.order_id
                    quizId = orderToken.quiz_id || ''
                } catch (err) {
                    orderId = null
                    this.status = 'CANCEL'
                }
            }

            if (orderId) {
                const request = new Request()

                request
                    .post(appConfig.api.vippsOrderDetail, { orderId: orderId })
                    .then(res => {
                        if (res.data.status_code == 200) {
                            const payment = res.data.data

                            this.status = payment.transactionInfo.status
                            this.transactionInfo = payment.transactionLogHistory[0]
                        }
                    })
                    .finally(() => {
                        this.createOrder(orderId, quizId)
                        if (window.opener) {
                            this.coundownClosed()
                            window.opener.postMessage(
                                JSON.stringify({
                                    action: 'vipps-payment-info',
                                    status: this.status
                                }),
                                '*'
                            )
                        }
                    })
            } else {
                this.status = 'CANCEL'
                if (window.opener) {
                    this.coundownClosed()
                }
            }
        },

        createOrderByToken(token) {
            const request = new Request()

            return new Promise((resolve, reject) => {
                request
                    .post(appConfig.api.vippsCheckTokenCode, { token })
                    .then(res => {
                        this.userInfo = res.data.data.user
                        resolve(res.data.data)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },

        coundownClosed(sec = 7) {
            this.closeTimer = sec
            this.timerInterval = setInterval(() => {
                this.closeTimer--
            }, 1000)
        },

        closeAction() {
            clearInterval(this.timerInterval)
            if (window.opener) {
                window.opener.postMessage(
                    JSON.stringify({
                        action: 'vipps-close-landing',
                        status: 'CLOSE'
                    }),
                    '*'
                )
            }
        },

        currentUser() {
            if (this.userInfo.id && this.userInfo.email) {
                return this.userInfo
            }

            return currentUser()
        },

        createOrder(orderId, quizId) {
            if (this.status == 'RESERVE') {
                const request = new Request()
                var configFilter = {}

                const type = this.transactionInfo.transactionText.match(/24 hour/)
                    ? 'access'
                    : this.transactionInfo.transactionText.match(/question/)
                    ? 'ai-question'
                    : 'credit'
                const configItemList =
                    appConfig[
                        type == 'access' ? 'payPlayerPlans' : type == 'ai-question' ? 'aiQuestionPlan' : 'buyCreditPlan'
                    ]

                this.vippsType = type

                if (type == 'ai-question') {
                    configFilter = configItemList.filter(item => {
                        return item.nok_amount == this.transactionInfo.amount / 10000
                    })
                } else {
                    configFilter = configItemList.filter(item => item.priceKr == this.transactionInfo.amount / 10000)
                }

                var payload = {
                    order_id: orderId,
                    payer_name: this.currentUser().name,
                    payer_email: this.currentUser().email,
                    payer_id: this.currentUser().id,
                    amount: configFilter[0].price,
                    user_id: this.currentUser().id,
                    method: 'vipps',
                    quiz_id: quizId
                }

                if (type == 'access') {
                    this.priceMessage = configFilter[0].priceKr + ' kr'

                    payload['data'] = {
                        limit_player: configFilter[0].limitPlayer
                    }
                } else if (type == 'credit') {
                    this.priceMessage = configFilter[0].priceKr + ' kr'

                    payload['credits'] = parseFloat(configFilter[0].credit).toFixed(2)
                    payload['type'] = 'buy-credit'
                } else {
                    this.limitQuestions = configFilter[0].limit

                    payload['type'] = 'ai-question'
                    payload['data'] = {
                        limit_player: configFilter[0].limit
                    }
                }

                request.post(appConfig.api.saveBuyPlayerOrder, payload).then(() => {
                    if (type == 'credit') {
                        this.$store.dispatch('getCredit')
                    }

                    window.localStorage.removeItem(`${currentUser().id}-vipps-orderId`)
                })
            }
        },

        doneAction() {
            if (this.checkIsLoggedIn) {
                return (window.location.href = this.$router.resolve({ name: 'order' }).href)
            }

            return (window.location.href = '/')
        }
    }
}
</script>

<style lang="scss">
.custom-loading {
    position: static;
}
</style>
